import gql from 'graphql-tag';

export const matriculasInfo = `
    id
    matricula {
      id
      documentName
      documentUrl
    }
    kml {  
      id  
      documentName
      documentUrl
    }
    fieldMonitoringFiles {
      id  
      documentName
      documentUrl
    }
    details {
      id
      emissionDate
      state {
        id
        code
        name
      }
      totalArea
      owners
      farmName
      registrationNumbers
      matriculaNumber
      detailType
      biome
      latitude
      longitude
      cultivableArea
      preservationArea
      otherArea
      complianceConflictArea
      ibamaEmbargo
      conservationUnities
      indigenousLand
      ICMBIOEmbargo
      stateEmbargo
      quilimbolasLand
      legalComments
      permanentPreservationArea
      deforestationAfter2008
      municipality {
        id
        code
        name
      }
      vegaReportDate
    }
`;

export const getAgFinancingMatriculas = gql`
  query findAgFinancingMatriculas($agFinancingId: ID!) {
    findAgFinancingMatriculas(agFinancingId: $agFinancingId) {
      ${matriculasInfo}
    }
  }
`;

export const updateAgFinancingMatricula = gql`
  mutation upsertAgFinancingMatricula($matricula: AgFinancingMatriculaInput!, $agFinancingId: ID!) {
    upsertAgFinancingMatricula(matricula: $matricula, agFinancingId: $agFinancingId) {
      id
    }
  }
`;
